//  Has access to dashboard
export const ROLE_DASHBOARD = 'ROLE_DASHBOARD';

// Has role of case nurse
export const ROLE_CASE_NURSE = 'ROLE_CASE_NURSE';

// Can access the DSS
export const ROLE_DSS = 'ROLE_DSS';

// string role for access to the DSS algorithm, can see the algorithm that was executed
export const  ROLE_DSS_ALGORITHM_ACCESS = "ROLE_DSS_ALGORITHM_ACCESS";

// Can access the Expert Tool
export const ROLE_EXPERT_TOOL = 'ROLE_EXPERT_TOOL';

// Has role of an expert (aka specialist/cardiologist)
export const ROLE_EXPERT = 'ROLE_EXPERT';

// Has the admin role and can do anything.
export const ROLE_ADMIN = 'ROLE_ADMIN';

// a role specifically for EDC api access, should not matter in front-end
export const ROLE_EDC_API = 'ROLE_EDC_API';

// Read Only user, can not make any changes to the PPP models but only view them
export const ROLE_READ_ONLY = 'ROLE_READ_ONLY';

// Read/Write user, has full read write access (overrides ROLE_READ_ONLY)
export const ROLE_READ_WRITE = 'ROLE_READ_WRITE';

// Can access all patients without needing to have access to their specific site or country */
export const ROLE_ALL_PATIENTS = "ROLE_ALL_PATIENTS";

// EDC role CRA
export const ROLE_CRA = 'ROLE_CRA';

// EDC role Lead CRA
export const ROLE_LEAD_CRA = 'ROLE_LEAD_CRA';

export const ROLE_REPORTS = 'ROLE_REPORTS';

export default {
  ROLE_CASE_NURSE: [ROLE_EXPERT_TOOL],
  ROLE_DSS: [ROLE_DASHBOARD],
  ROLE_DSS_ALGORITHM_ACCESS: [ROLE_DSS],
  ROLE_EXPERT_TOOL: [ROLE_DASHBOARD],
  ROLE_EXPERT: [ROLE_CASE_NURSE, ROLE_DSS, ROLE_EXPERT_TOOL],
  ROLE_CRA : [ROLE_READ_ONLY, ROLE_EXPERT],
  ROLE_LEAD_CRA : [ROLE_CRA],
  ROLE_EDC_API: [ROLE_ALL_PATIENTS],
  ROLE_ADMIN: [ROLE_EXPERT, ROLE_EDC_API, ROLE_ALL_PATIENTS, ROLE_READ_WRITE, ROLE_DSS_ALGORITHM_ACCESS, ROLE_REPORTS],
  ROLE_REPORTS: []
}

